import { useState, useEffect, useCallback } from "react";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";

import moment from "moment";
import "moment/locale/pt-br";

import { Stack, Button } from "@mui/material";

/* hooks */
import useFlashMessage from "../../../hooks/useFlashMessage";
import { useNavigateParams } from "../../../hooks/useNavigateParams";

import Input from "../../form/Input";
import InputNumber from "../../form/InputNumber";
import Select from "../../form/Select";
import Checkbox from "../../form/Checkbox";
import SelectEmpresa from "../../form/SelectEmpresa";

import formStyles from "../../form/Form.module.css";

/* funções */
import { retornaDataHora } from "../../../utils/retornaDataFormatada";

/* utils */
import { formatarNumero, formatarNumeroDecimal } from "../../../utils/masks";
import maskCPForCNPJ from "../../../utils/maskCPForCNPJ";

function Form({
    token,
    handleSubmit,
    formData,
    btnText,
    params,
    caminhoVoltar,
    EnumTipo,
    EnumVinculoFinanceiro,

    OptionsEmpresa,
}) {
    const [preview, setPreview] = useState([]);
    const [pessoa, setPessoa] = useState({});

    const [pessoaUsuario, setPessoaUsuario] = useState({});

    //obtem o array de empresas vinculadas ou coloca a empresaId no array
    const empresaId = localStorage.getItem("empresaId");

    //abas
    const [tabEnabled, setTabEnabled] = useState({});

    useEffect(() => {
        setPessoa(formData || {});
        setPessoaUsuario(formData?.pessoaUsuario || {});

        setTabEnabled({
            pessoa: true,
            usuario: localStorage.getItem("usuario") ? true : false,
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData]);

    //atualiza as tabelas filhas
    useEffect(() => {
        setPessoa((prev) => ({ ...prev, pessoaUsuario: pessoaUsuario }));
    }, [pessoaUsuario]);

    const navigate = useNavigateParams();

    async function onFileChange(e) {
        setPreview(Array.from(e.target.files));
        setPessoa({ ...pessoa, images: [...e.target.files] });
    }
    async function handleChange(e) {
        const { name, value, checked, type, options, selectedIndex } = e.target;

        const camposBooleanos = ["ativo", "funcionario", "usuario"];

        //atualiza as opções dos objetos filhos
        if (camposBooleanos.includes(name)) {
            setPessoa({ ...pessoa, [name]: checked });
        } else if (name.startsWith("pessoaUsuario.")) {
            setPessoaUsuario({
                ...pessoaUsuario,
                [name.split(".")[1]]: type === "checkbox" ? checked : value,
            });
        } else {
        }
    }
    async function handleOnBlur(e) {}
    async function handleOnFocus(e) {}

    const submit = (e) => {
        e.preventDefault();

        handleSubmit(pessoa);
    };

    return (
        <Tabs>
            <form onSubmit={submit}>
                <h1>Gestão de Usuários</h1>
                <TabList>
                    <Tab disabled={!tabEnabled.pessoa} title={"Infomações genericas da pessoa"}>
                        Pessoa
                    </Tab>
                    <Tab disabled={!tabEnabled.usuario} title={"Víncula a pessoa a um usuário do sistema"}>
                        Usuário
                    </Tab>
                </TabList>

                <TabPanel>
                    <div className={formStyles.stiloPadrao}>
                        <h4>Informações principais da Pessoa</h4>

                        <div className={formStyles.preview_bandeira}>
                            <div>
                                <Input
                                    text="Fotos da Pessoa"
                                    type="file"
                                    name="images"
                                    accept=".jpg, .jpeg, .png"
                                    handleOnChange={onFileChange}
                                    multiple={false}
                                    inputWidth="350px"
                                    disabled={true}
                                />
                            </div>
                            {preview.length > 0
                                ? preview.map((image, index) => (
                                      <img
                                          src={URL.createObjectURL(image)}
                                          alt={pessoa.images}
                                          key={`${pessoa.images}+${index}`}
                                          style={{
                                              borderColor: "black",
                                              border: "solid 0.05em",
                                          }}
                                          width={60}
                                          height={80}
                                      />
                                  ))
                                : pessoa.images && (
                                      <img
                                          src={process.env.REACT_APP_API + "imagens/" + pessoa.images}
                                          alt={pessoa.uuid || "Foto da Pessoa"}
                                          style={{
                                              borderColor: "black",
                                              border: "solid 0.05em",
                                          }}
                                          width={60}
                                          height={80}
                                      />
                                  )}
                        </div>
                        <div>
                            <SelectEmpresa
                                name="empresaId"
                                text="Empresa"
                                options={OptionsEmpresa}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.empresaId}
                                isEnum={false}
                                notOptNull={true}
                            />
                            <Input
                                text="Data Cadastro"
                                type="datetime-local"
                                name="createdAt"
                                placeholder="última atualização"
                                title="Data de inserção do cadastro no sistema"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={(pessoa.createdAt && retornaDataHora(pessoa.createdAt)) || retornaDataHora(moment())}
                                readonly={true}
                            />
                            <Input
                                text="Data Atualização"
                                type="datetime-local"
                                name="updatedAt"
                                placeholder="última atualização"
                                title="Data da última atualização dos dados"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={(pessoa.updatedAt && retornaDataHora(pessoa.updatedAt)) || retornaDataHora(moment())}
                                readonly={true}
                            />
                        </div>
                        <div>
                            <Input
                                text="CPF ou CNPJ"
                                type="text"
                                name="CPForCNPJ"
                                placeholder="CPF ou CNPJ da Pessoa"
                                title="Digite o CPF ou CNPJ da pessoa"
                                minlength={14}
                                maxlength={18}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.CPForCNPJ ? maskCPForCNPJ(pessoa.CPForCNPJ) : ""}
                                required
                                readonly={false}
                            />
                            <Input
                                text="RG ou IE"
                                type="text"
                                name="RGorIE"
                                placeholder="RG ou IE da Pessoa"
                                title="Digite o Registro Geral ou Inscrição Estadual da pessoa"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.RGorIE ?? ""}
                                required={false}
                                readonly={false}
                            />
                            <Select
                                name="tipo"
                                text="Pessoa"
                                title="Identifica se a pessoa é física ou jurídica"
                                options={EnumTipo}
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.tipo || "Jurídica"}
                                isEnum={true}
                            />
                        </div>
                        <div>
                            <Input
                                text="Nome Principal"
                                type="text"
                                name="nomePrincipal"
                                placeholder="Nome"
                                title="nome atual da pessoa"
                                inputWidth="350px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.nomePrincipal || ""}
                                readonly={false}
                            />
                            <Checkbox
                                title="Funcionário da empresa"
                                text="Funcionário"
                                name="funcionario"
                                type="checkbox"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.funcionario}
                                checked={pessoa.funcionario === true ? "checked" : ""}
                            />
                            <Checkbox
                                title="Usuário da empresa"
                                text="Usuário"
                                name="usuario"
                                type="checkbox"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.usuario}
                                checked={pessoa.usuario === true ? "checked" : ""}
                            />
                            <Checkbox
                                title="Ativa ou Inativa a pessoa"
                                text="Ativo"
                                name="ativo"
                                type="checkbox"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoa.ativo}
                                checked={pessoa.ativo === true ? "checked" : ""}
                            />
                        </div>
                    </div>
                </TabPanel>

                <TabPanel>
                    <div className={formStyles.formPai}>
                        <h4>Configura usuário do sistema e sua permissões</h4>
                        <div className={formStyles.formFilho}>
                            <h4>Usuário</h4>
                            <Input
                                text="Usuário"
                                type="text"
                                name="pessoaUsuario.usuario"
                                placeholder="Usuário"
                                title="nome do usuário"
                                //inputWidth="350px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoaUsuario.usuario}
                                readonly={false}
                            />
                            <Checkbox
                                title="Caso desmarcado o usuário não poderá acessar o sistema"
                                text="Ativo"
                                name="pessoaUsuario.ativo"
                                type="checkbox"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoaUsuario.ativo}
                                checked={pessoaUsuario.ativo === true ? "checked" : ""}
                            />
                            <Checkbox
                                title="Ativado para administradores do sistema"
                                text="Administrador"
                                name="pessoaUsuario.isAdmin"
                                type="checkbox"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoaUsuario.isAdmin}
                                disabled={JSON.parse(localStorage.getItem("isAdmin")) === true ? false : true}
                                checked={pessoaUsuario.isAdmin === true ? "checked" : ""}
                            />
                            <Input
                                text="Senha"
                                type="password"
                                name="pessoaUsuario.senha"
                                placeholder="Senha"
                                title="Senha do usuário"
                                //inputWidth="350px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoaUsuario.senha}
                                readonly={false}
                            />
                            <Input
                                text="Confirme a senha"
                                type="password"
                                name="pessoaUsuario.confirmeSenha"
                                placeholder="Conrfirme a senha"
                                title="confirmação de senha do usuário"
                                //inputWidth="350px"
                                handleOnChange={handleChange}
                                handleOnFocus={handleOnFocus}
                                handleOnBlur={handleOnBlur}
                                value={pessoaUsuario.confirmeSenha}
                                readonly={false}
                            />
                        </div>
                        <div className={formStyles.formFilho}>
                            <h4>Administrativo</h4>
                            <div className={formStyles.formFilho}>
                                <h4>Plantão</h4>
                                <Checkbox
                                    title="Permite o usuário alterar a data do plantão"
                                    text="Data"
                                    name="pessoaUsuario.plantaoAlteraData"
                                    type="checkbox"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoaUsuario.plantaoAlteraData}
                                    checked={pessoaUsuario.plantaoAlteraData === true ? "checked" : ""}
                                />
                                <Checkbox
                                    title="Permite o usuário concluir o plantão"
                                    text="Conclui"
                                    name="pessoaUsuario.plantaoPermiteConcluir"
                                    type="checkbox"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoaUsuario.plantaoPermiteConcluir}
                                    checked={pessoaUsuario.plantaoPermiteConcluir === true ? "checked" : ""}
                                />
                                <Checkbox
                                    title="Permite o usuário assinar o plantão"
                                    text="Assina"
                                    name="pessoaUsuario.plantaoAssinatura"
                                    type="checkbox"
                                    handleOnChange={handleChange}
                                    handleOnFocus={handleOnFocus}
                                    handleOnBlur={handleOnBlur}
                                    value={pessoaUsuario.plantaoAssinatura}
                                    checked={pessoaUsuario.plantaoAssinatura === true ? "checked" : ""}
                                />
                            </div>
                        </div>
                        <div className={formStyles.formFilho}>
                            <h4>Cadastros</h4>
                            <div className={formStyles.formFilho}>
                                <h4>---</h4>
                            </div>
                        </div>
                    </div>
                </TabPanel>

                <div>
                    <Stack direction="row" spacing={1}>
                        <Button variant="contained" color="secondary" onClick={() => navigate(caminhoVoltar, params)}>
                            Voltar
                        </Button>
                        <Button type="submit" variant="contained" color="success" disabled={!pessoa.nomePrincipal}>
                            {btnText}
                        </Button>
                    </Stack>
                </div>
            </form>
        </Tabs>
    );
}

export default Form;
